/**
 * ATTENTION! This file is auto-generated for the 'grasias' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { DocImportsRepository } from '../server/repositories/DocImportsRepository';
import type { ContractorDocsListRepository } from '../server/repositories/ContractorDocsListRepository';
import type { GrasiasDealExpensesRepository } from '../server/repositories/GrasiasDealExpensesRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type DocImportsRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DocImportsRepository>;
export function useDocImportsRepository(): DocImportsRepositoryClient { return makeRepositoryProxy<DocImportsRepositoryClient>('grasias::DocImportsRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDocImportsRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const docImportsRepository = useDocImportsRepository();

type ContractorDocsListRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ContractorDocsListRepository>;
export function useContractorDocsListRepository(): ContractorDocsListRepositoryClient { return makeRepositoryProxy<ContractorDocsListRepositoryClient>('grasias::ContractorDocsListRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useContractorDocsListRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const contractorDocsListRepository = useContractorDocsListRepository();

type GrasiasDealExpensesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<GrasiasDealExpensesRepository>;
export function useGrasiasDealExpensesRepository(): GrasiasDealExpensesRepositoryClient { return makeRepositoryProxy<GrasiasDealExpensesRepositoryClient>('grasias::GrasiasDealExpensesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useGrasiasDealExpensesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const grasiasDealExpensesRepository = useGrasiasDealExpensesRepository();

type unlinkPartnerFrom1cType = typeof import('../server/functions/unlinkPartnerFrom1c').unlinkPartnerFrom1c;
export const unlinkPartnerFrom1c: RpcFunctionClient<unlinkPartnerFrom1cType> = makeFunctionProxy<unlinkPartnerFrom1cType>('grasias::unlinkPartnerFrom1c');

type hasPartner1cLinkType = typeof import('../server/functions/hasPartner1cLink').hasPartner1cLink;
export const hasPartner1cLink: RpcFunctionClient<hasPartner1cLinkType> = makeFunctionProxy<hasPartner1cLinkType>('grasias::hasPartner1cLink');

type checkDealStatusType = typeof import('../server/functions/checkDealStatus').checkDealStatus;
export const checkDealStatus: RpcFunctionClient<checkDealStatusType> = makeFunctionProxy<checkDealStatusType>('grasias::checkDealStatus');

type recalcDealStatusType = typeof import('../server/functions/recalcDealStatus').recalcDealStatus;
export const recalcDealStatus: RpcFunctionClient<recalcDealStatusType> = makeFunctionProxy<recalcDealStatusType>('grasias::recalcDealStatus');

type createDealFromLeadType = typeof import('../server/functions/createDealFromLead').createDealFromLead;
export const createDealFromLead: RpcFunctionClient<createDealFromLeadType> = makeFunctionProxy<createDealFromLeadType>('grasias::createDealFromLead');
